import { useQuery } from 'react-query';

import { getMilestones as queryFn } from 'api/endPoints/getMilestones';

import { IMilestones } from 'components/Dashboards/Portfolio/phasePerformance/manage/manage.types';

export const useQueryGetMilestones = (contractId) => {
    return useQuery<IMilestones[], QueryError>(['phasePerformanceMilestones', contractId], () => queryFn(contractId), {
        enabled: Boolean(contractId),
    });
};
